module.exports = __webpack_public_path__ + "static/media/stewartisland.32f1c944.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/panoramas/stewartisland.JPG
// module id = 265
// module chunks = 0